var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { cherryPickTranslations, fetchTranslations } from './i18n/i18n';
import { useCarlineStore } from './store/carline';
import useTranslations from './store/translations';
import { FeatureServicesProvider } from './provider/feature-services-provider';
import { App } from './app';
import useMarketConfig from './store/market-config';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { FootnoteContextProvider } from '@oneaudi/feature-app-utils';
import { FeatureAppLoader } from '@feature-hub/react';
import styled from 'styled-components';
export const CompareLayer = ({ data, actions, config, language, services, marketConfig, }) => {
    var _a, _b, _c;
    const { appConfig, setAppConfig, setConfiguredCar, setConfiguredCarline, setStandardEquipmentInitialCar, setStandardEquipmentCompareCar, setSelectedEngine, setSecondSelectedEngine, setActions, setCompare, setFinancialDisclaimer, setIsDebugMode, } = useCarlineStore();
    const { setTranslations } = useTranslations();
    const { setMarketConfig, marketConfig: marketConfigStore } = useMarketConfig();
    useEffect(() => {
        if (config === null || config === void 0 ? void 0 : config.isDebugMode) {
            setIsDebugMode(config.isDebugMode);
        }
    }, [config === null || config === void 0 ? void 0 : config.isDebugMode, setIsDebugMode]);
    useEffect(() => {
        if (config === null || config === void 0 ? void 0 : config.isCompareActive) {
            setCompare(true);
        }
    }, [config === null || config === void 0 ? void 0 : config.isCompareActive, setCompare]);
    useEffect(() => {
        if (config) {
            setAppConfig(config);
        }
    }, [config, appConfig, setAppConfig]);
    useEffect(() => {
        if (actions) {
            setActions(actions);
        }
    }, [actions, setActions]);
    useEffect(() => {
        if (data === null || data === void 0 ? void 0 : data.selectedDriveTrain) {
            setSelectedEngine(data.selectedDriveTrain);
        }
        if (data.selectedDriveTrainCompare) {
            setSecondSelectedEngine(data.selectedDriveTrainCompare);
        }
        if (data.configuredCar) {
            setConfiguredCar(data.configuredCar);
            setConfiguredCarline(data.configuredCar.carlineStructureCarline);
        }
        if (data.standardEquipmentInitialCar) {
            setStandardEquipmentInitialCar(data.standardEquipmentInitialCar);
        }
        if (data.standardEquipmentCompareCar) {
            setStandardEquipmentCompareCar(data.standardEquipmentCompareCar);
        }
        if (data.financialDisclaimer) {
            setFinancialDisclaimer(data.financialDisclaimer);
        }
    }, [
        setConfiguredCar,
        data.configuredCar,
        setStandardEquipmentInitialCar,
        setStandardEquipmentCompareCar,
        data.standardEquipmentInitialCar,
        data.standardEquipmentCompareCar,
        setConfiguredCarline,
        setSelectedEngine,
        data.selectedDriveTrain,
        setSecondSelectedEngine,
        data.selectedDriveTrainCompare,
        setFinancialDisclaimer,
        data.financialDisclaimer,
    ]);
    useEffect(() => {
        if (!marketConfigStore && marketConfig) {
            setMarketConfig(marketConfig);
        }
    }, [marketConfig, marketConfigStore, setMarketConfig]);
    useEffect(() => {
        const fetchAndSetTranslations = () => __awaiter(void 0, void 0, void 0, function* () {
            if (services.i18nService) {
                try {
                    setTranslations(cherryPickTranslations(services.i18nService.getMessages(), language));
                }
                catch (e) {
                    const translations = yield fetchTranslations(language, services.i18nService);
                    setTranslations(translations);
                }
            }
        });
        fetchAndSetTranslations();
    }, [services.i18nService, language, setTranslations]);
    useEffect(() => {
        return () => {
            setActions({});
            setAppConfig(null);
            setCompare(false);
            setSelectedEngine(null);
            setSecondSelectedEngine(null);
            setConfiguredCar({});
            setConfiguredCarline({});
            setStandardEquipmentInitialCar([]);
            setStandardEquipmentCompareCar([]);
        };
    }, [
        setActions,
        setAppConfig,
        setCompare,
        setSelectedEngine,
        setSecondSelectedEngine,
        setConfiguredCar,
        setConfiguredCarline,
        setStandardEquipmentInitialCar,
        setStandardEquipmentCompareCar,
    ]);
    const _footnoteReferenceService = (data === null || data === void 0 ? void 0 : data.footnoteLayerId)
        ? (_a = services === null || services === void 0 ? void 0 : services.footnoteReferenceService) === null || _a === void 0 ? void 0 : _a.getCustomScopeRefService(data === null || data === void 0 ? void 0 : data.footnoteLayerId)
        : (_b = services === null || services === void 0 ? void 0 : services.footnoteReferenceService) === null || _b === void 0 ? void 0 : _b.getDefaultScopeRefService();
    const customLayerId = (_c = data === null || data === void 0 ? void 0 : data.footnoteLayerId) !== null && _c !== void 0 ? _c : 'custom-footnotes-layer';
    return (_jsx(ThemeProvider, { children: _jsx(FootnoteContextProvider, { footnoteReferenceService: _footnoteReferenceService, children: _jsx(FeatureServicesProvider.Provider, { value: services, children: _jsxs("div", { "data-fefa-custom-id": _footnoteReferenceService === null || _footnoteReferenceService === void 0 ? void 0 : _footnoteReferenceService.getConsumerId(), children: [_jsx(App, { actions: actions }), _jsx(StyledFefaFooter, { children: _jsx(FeatureAppLoader, { featureAppId: customLayerId, src: "https://fa-footnote-engine.cdn.prod.arcade.apps.one.audi/v2.8.0/fh/app.js", config: {
                                    apiUrls: ['/fefa-test.json'],
                                    layerElementClassName: customLayerId,
                                    uiTheme: 'light',
                                } }) })] }) }) }) }));
};
const StyledFefaFooter = styled.div `
  & > div {
    padding: 16px !important;
  }
`;
